var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tax_info_row",on:{"click":function($event){return _vm.edit_tax_empinfo()}}},[_c('div',[_c('span',[_vm._v("Tax info")]),_c('span',[_vm._v(" from "+_vm._s(_vm.start_date))]),(_vm.tax_empinfo.end_date)?_c('span',[_vm._v(" until "+_vm._s(_vm.end_date))]):_vm._e(),_c('span',[_vm._v(", "+_vm._s(_vm.tax_empinfo.status_desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }